import { formatFeePct } from 'config/economyCopy';

/**
 * Tooltip copy for the Point Fee line on a Sending trade card.
 *
 * - Exempt (server's feeExempt: a trade-offer leg or an Elite sender): says why
 *   there is no fee. An Elite viewer gets the Elite badge tooltip instead, so
 *   this branch only ever renders for an exempt offer leg.
 * - Not exempt: names the live rate; until the rate loads the sentence carries
 *   no number rather than a stale default.
 *
 * Exemption is the server's flag, never inferred from tradeFee === 0: fees
 * round down, so a small trade's fee is 0 without being exempt.
 */
export const feeLineTooltip = (
  feeExempt: boolean | undefined,
  viewerIsElite: boolean,
  ratePct: number | undefined
): string => {
  if (feeExempt) {
    return viewerIsElite ? 'As an Elite user, you pay zero fees' : 'Trade offer legs carry no fee.';
  }
  const rate = ratePct != null ? ` of ${formatFeePct(ratePct)}` : '';
  return `To maintain the long-term sustainability of our trading economy, we apply a flexible trade fee${rate} to each completed trade.`;
};
